import styled from "styled-components";

export const NotFoundPageContainer = styled.div`
  margin-top: 70px;
  width: 100%;
  padding: 35px;
  padding-left: 95px;
  box-sizing: border-box;
  background-color: #fafafafa;
  height: 100%;
  position: absolute;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 180px;
`;
